import { apiClient } from "../config";

async function getAllPermissions(roleId: any) {
  const res = await apiClient.get(`/admin/permissions/${roleId}`);
  return res.data;
}

export default getAllPermissions;
